export const IDENTIFY_SET_LOADING = 'IDENTIFY:SET_LOADING';
// export const IDENTIFY_RECORD_LIST_LOADED = 'IDENTIFY:RECORD_LIST_LOADED';
// export const IDENTIFY_RECORD_LIST_LOAD_ERROR = 'IDENTIFY:RECORD_LIST_LOAD_ERROR';
export const IDENTIFY_CHANGE_PAGE = 'IDENTIFY:CHANGE_PAGE';
export const IDENTIFY_NEW_REQUEST = 'IDENTIFY:NEW_REQUEST';
export const IDENTIFY_PURGE_RESULTS = 'IDENTIFY:PURGE_RESULTS';
export const IDENTIFY_LOAD_FEATURE_INFO = 'IDENTIFY:LOAD_FEATURE_INFO';
export const IDENTIFY_EXCEPTIONS_FEATURE_INFO = 'IDENTIFY:EXCEPTIONS_FEATURE_INFO';
export const IDENTIFY_ERROR_FEATURE_INFO = 'IDENTIFY:ERROR_FEATURE_INFO';
